<template>
  <div class="main-content-container container-fluid h-100 px-4">
    <d-row no-gutters class="h-100">
      <d-col lg="3" md="5" class="auth-form mx-auto my-auto">
        <d-card>
          <d-card-body>
            <!-- Logo -->
            <img
              class="d-table mx-auto mb-3"
              src="@/assets/images/omja.png"
              alt="Omja Software - Login"
            />

            <!-- Title -->
            <h5 class="auth-form__title text-center mb-4">
              {{ $t("forgot.password.title") }}
            </h5>

            <!-- Form Fields -->
            <d-form @submit.prevent="onSubmit">
              <div class="form-group mb-4">
                <label for="exampleInputEmail1">{{ $t("user.email") }}</label>
                <d-input
                  type="email"
                  :state="errors['email'] === undefined ? null : false"
                  id="exampleInputEmail1"
                  v-model="model.email"
                  :placeholder="$t('user.your.email')"
                />
                <d-form-text class="text-muted text-center">{{
                  $t("forgot.password.notice")
                }}</d-form-text>
                <errors :errors="errors" field="email" />
              </div>
              <button
                type="submit"
                class="btn btn-pill btn-accent d-table mx-auto"
              >
                {{ $t("forgot.password.new.password") }}
              </button>
            </d-form>
          </d-card-body>
        </d-card>

        <!-- Meta -->
        <div class="auth-form__meta d-flex mt-4">
          <d-link tag="a" to="login" class="mx-auto">{{
            $t("global.return")
          }}</d-link>
        </div>
      </d-col>
    </d-row>
  </div>
</template>

<script>
import Errors from '../components/error/errors.vue';
import ErrorsHelper from '../helper/ErrorsHelper';

export default {
  name: 'forgot-password',
  components: { Errors },
  data() {
    return {
      model: {
        email: '',
      },
      requiredFields: ['email'],
      errors: {},
    };
  },

  methods: {
    onSubmit() {
      this.errors = {};
      if (
        ErrorsHelper.checkErrors(this.requiredFields, this.model, this.errors)
      ) {
        this.$services.user
          .resetPassword(this.model)
          .then(() => {
            this.$miniToastr.success(this.$t('forgot.password.success'));
            this.$router.push('/login');
          })
          .catch((error) => {
            console.warn('error', error);
          });
      }
    },
  },
};
</script>
